export enum BACKGROUND_CHECK_STATUS {
  PENDING_ADMIN_INPUT = "PENDING_ADMIN_INPUT",
  PENDING_PROVIDER_INPUT = "PENDING_PROVIDER_INPUT",
  IN_REVIEW = "IN_REVIEW",
  REJECTED = "REJECTED",
  APPROVED = "APPROVED",
}
